export const normalizeAmount = (value?: number | null): number => value ?? 0;

export const formatRupiah = (value?: number | null): string => {
  return `Rp. ${new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(normalizeAmount(value))}`;
};

export const parseRupiahInput = (value: string): string => {
  return value.replace(/\D/g, "");
};

export const formatRupiahInputValue = (value: string): string => {
  const digits = parseRupiahInput(value);
  if (digits === "") {
    return "";
  }

  const num = Number(digits);
  if (Number.isNaN(num)) {
    return "";
  }

  return formatRupiah(num);
};
